import { type MotifComponent, type MotifComponentProps } from '../../motif';
import { m } from '../../motif/m';

export const iconDefaultVars: MotifComponentProps<MotifComponent.ICON> = {
  '--icon-color': m('--foreground-color'),
};
